import React, { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { FaMagnifyingGlass } from "react-icons/fa6";
import MobileView from "../../components/MobileView";
import TableUI from "../../components/Table";
import { TextInputForm } from "../../components/Forms";
import { ClickButton } from "../../components/ClickButton";
import API_DOMAIN from "../../config/config";
import { Buttons } from "../../../src/components/Buttons";
import { useMediaQuery } from "react-responsive";

import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../../components/LoadingOverlay";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

const Customer = () => {
  const navigate = useNavigate();
  const CustomerTablehead = [
    "No",
    "customer No",
    "Customer Name",
    "Mobile No.",
    "Action",
  ];
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const itemsPerPage = 10;

  const [customerData, setcustomerData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    ReceiptNo: "",
  });
  const fetchDatajewelpawncustomer = async (page = 1) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/customer.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: searchText,
          limit: itemsPerPage,
          offset: (page - 1) * itemsPerPage,
        }),
      });

      const responseData = await response.json();
      console.log(responseData);

      if (responseData.head.code === 200) {
        setcustomerData(responseData.body.customer);
        setLoading(false);
        setTotalRecords(responseData.body.total_records);
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };
  useEffect(() => {
    fetchDatajewelpawncustomer(currentPage);

  }, [searchText, formData, currentPage, itemsPerPage]);
  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };

  const nextPage = () => {
    if (currentPage < Math.ceil(totalRecords / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  return (
    <div>
      <Container fluid>
        <Row>
          <Col lg="7" md="4" xs="6">
            <div className="page-nav py-3">
              <span class="nav-list">Customer</span>
            </div>
          </Col>
          <Col lg="5" md="3" xs="6" className="align-self-center text-end">
            <ClickButton
              label={<>Add New</>}
              onClick={() => navigate("/console/master/customer/create")}
            />
          </Col>

          <Col lg="3" md="5" xs="12" className="py-1">
            <TextInputForm
              placeholder={"Name, mobile number"}
              onChange={(e) => handleSearch(e.target.value)}
              prefix_icon={<FaMagnifyingGlass />}
            >
              {" "}
            </TextInputForm>
          </Col>
          <Col lg={9} md={12} xs={12} className="py-2"></Col>
          {loading ? (
            <LoadingOverlay isLoading={loading} />
          ) : (
            <Col lg="12" md="12" xs="12" className="px-0">
              <div className="py-1">

                <div className="text-end">
                  <span className="mx-1">
                    Page {currentPage} of{" "}
                    {Math.ceil(totalRecords / itemsPerPage)}
                  </span>
                  <span className="mx-1">
                    <Buttons
                      lable={<MdChevronLeft />}
                      onClick={prevPage}
                      disabled={currentPage === 1}
                    />
                  </span>
                  <span className="mx-1">
                    <Buttons
                      lable={<MdChevronRight />}
                      onClick={nextPage}
                      disabled={
                        currentPage === Math.ceil(totalRecords / itemsPerPage)
                      }
                    />
                  </span>
                </div>
                <TableUI
                  headers={CustomerTablehead}
                  body={customerData}
                  type="customer"
                  pageview={"no"}
                />
                <div className="text-end">
                  <span className="mx-1">
                    Page {currentPage} of{" "}
                    {Math.ceil(totalRecords / itemsPerPage)}
                  </span>
                  <span className="mx-1">
                    <Buttons
                      lable={<MdChevronLeft />}
                      onClick={prevPage}
                      disabled={currentPage === 1}
                    />
                  </span>
                  <span className="mx-1">
                    <Buttons
                      lable={<MdChevronRight />}
                      onClick={nextPage}
                      disabled={
                        currentPage === Math.ceil(totalRecords / itemsPerPage)
                      }
                    />
                  </span>
                </div>
              </div>
            </Col>
          )}
          <Col lg={12} md={12} xs={12}></Col>

        </Row>
      </Container>
    </div>
  );
};

export default Customer;
